module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/Variance-table.ejs -->\n<table class="footable footable-summary table table-stripped"\n       data-page-size="25" data-sorting="false">\n    <thead>\n        <tr>\n            <th>&nbsp;</th>\n            <th>Prev Payroll ('+
((__t=( prev.period ))==null?'':_.escape(__t))+
')</th>\n            <th>Last Payroll ('+
((__t=( last.period ))==null?'':_.escape(__t))+
')</th>\n            <th>Difference</th>\n        </tr>\n    </thead>\n    <tbody class="js-rows">\n        <tr>\n            <td>Base</td>\n            <td>'+
((__t=( prev.base ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.base ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.base ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Additions</td>\n            <td>'+
((__t=( prev.additions ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.additions ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.additions ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Deductions</td>\n            <td>'+
((__t=( prev.deductions ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.deductions ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.deductions ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Gross Pay</td>\n            <td>'+
((__t=( prev.grossPay ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.grossPay ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.grossPay ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>PCB</td>\n            <td>'+
((__t=( prev.mtd ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.mtd ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.mtd ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Employee EPF</td>\n            <td>'+
((__t=( prev.employeeEpf ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.employeeEpf ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.employeeEpf ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Employee SOCSO</td>\n            <td>'+
((__t=( prev.employeeSocso ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.employeeSocso ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.employeeSocso ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Employer EPF</td>\n            <td>'+
((__t=( prev.employerEpf ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.employerEpf ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.employerEpf ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Employer SOCSO</td>\n            <td>'+
((__t=( prev.employerSocso ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.employerSocso ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.employerSocso ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n        <tr>\n            <td>Net Pay</td>\n            <td>'+
((__t=( prev.netPay ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( last.netPay ))==null?'':_.escape(__t))+
'</td>\n            <td>'+
((__t=( diff.netPay ))==null?'':_.escape(__t))+
'</td>\n        </tr>\n\n\n    </tbody>\n    <tfoot>\n    </tfoot>\n</table>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/Variance-table.ejs
// module id = 833
// module chunks = 1